<template>
  <div>
    <div class="row">
      <div class="col" id="application-signed-date">
        <div class="small text-muted-more">{{ $t('LoanApplicationTimeline.contractSigned') }}</div>
        <div class="text-muted small">{{ $d(application.signedDate) }}</div>
      </div>
      <div class="col" id="application-reference-number">
        <div class="small text-muted-more">{{ $t('LoanApplicationTimeline.referenceNumber') }}</div>
        <div class="text-muted small">{{ application.reference }}</div>
      </div>
    </div>
    <div class="row" v-if="application.showContractLink">
      <div class="col">
        <router-link class="mt-3 small" :to="this.receiveContractRoute">
          {{ $t('LoanApplicationTimeline.receiveContract') }}
        </router-link>
      </div>
    </div>
  </div>
</template>
<script>

export default {
  name: 'SignedStageComponent',
  props: ['application'],
  computed: {
    receiveContractRoute() {
      if (this.$configuration.newCoreEnabled) {
        return { name: 'receive-loan-contract-signed-and-paid-out', params: { reference: this.application.reference } }
      }
      const isPaidOut = this.application.status === 'COMPLETED' && this.application.paidOutDate !== null
      return {
        name: isPaidOut ? 'receive-loan-contract-signed-and-paid-out' : 'receive-loan-contract-signed',
        params: {
          reference: this.application.reference
        }
      }
    }
  }
}
</script>
